import { css } from "styled-components";

const poppins_hero_base = css`
  font-family: var(--font-poppins);
  font-style: normal;
  font-weight: var(--text-weight-semibold);
`;

export const poppins_hero_lg = css`
  ${poppins_hero_base};
  font-size: var(--text-hero-size-lg);
  line-height: 5.2rem;
  letter-spacing: -0.4px;
`;

export const poppins_hero_md = css`
  ${poppins_hero_base};
  font-size: var(--text-hero-size-md);
  line-height: 4.16rem;
  letter-spacing: -0.32px;
`;

export const poppins_hero_sm = css`
  ${poppins_hero_base};
  font-size: var(--text-hero-size-sm);
  line-height: 3.64rem;
  letter-spacing: -0.28px;
`;
